/*
 * @Author: hasee
 * @Date:   2016-12-12 18:22:32
 * @Last Modified by:   hasee
 * @Last Modified time: 2017-01-16 18:11:43
 */
import axios from 'axios';
// Vuex
import Vue from 'vue';
import Vuex from 'vuex';

import APIS from '../apis';

Vue.use(Vuex);
import {callbackHandler} from './callbackHandler';
import {wxConfig} from '../lib/wxActions';
import { getPlatform } from '@/frontend-lib/tools/getPlatform'
// modules
import answer from './modules/answer'
import ad from './modules/ad'
import show from './modules/show'
import report from './modules/report'
import search from './modules/search'
import comment from './modules/comment'
import gift from './modules/gift'
import vip from './modules/vip'
import member from './modules/member'
import ceshi from './modules/ceshi'
import toutiao_app from './modules/toutiao_app'
import notLogin from './modules/notLogin'
import houseTreePeople from './modules/houseTreePeople'
import activity from './modules/activity'
import consult from './modules/consult'
import careercard from './modules/careercard'
import datura from './modules/datura'

const store = new Vuex.Store({
  modules: {
    answer,
    ad,
    show,
    search,
    report,
    comment,
    gift,
    vip,
    member,
    ceshi,
    toutiao_app,
    notLogin,
    houseTreePeople,
    activity,
    consult,
    careercard,
    datura
  },

  state: {
    // 是否微信小程序
    isWxApp: false,
    // 微信小程序sessionKey
    wxMiniAppSessionKey: '',
    // 微信config数据
    wxConfig: {},
    // 渠道ID
    channelId: null,
    // 渠道信息
    channelConfig: {},
    // 用户信息
    userInfo: {},
    /**
     * vip信息
     * vipInfo.vipIdentity|0--1.0会员, 1--2.0新会员, 2--2.0续费会员（1.0续费到2.0）, 3--3.0新会员, 4--3.0续费会员（2.0续费到3.0）, 5--4.0新会员, 6--4.0续费会员（3.0续费到4.0）
     * vipInfo.status|会员状态，0=禁止，1=正常，2=过期|
     * vipInfo.vipBuyType|会员购买测评类型  0-- 0元测  1--五折测 2--普通购买类型|
     */
    vipInfo:{},
    // 用来做题和报告页的时候记录cookie的，在main.js监视router.query设置
    uid: null,
    // 全局参数
    GLOBALLOCK: false,
    LOADING: false,
    LOADINGTEXT: '',
    TOASTTEXT: '',
    TOASTSTATUS: '',
    TOASTTIME: 1300,
    // 判断报告页显示不显示各部件
    isReportRecomendShowed: '',
    isReportShareShowed: '',
    isSendEmailShowed: '',
    // isVip: 0, //0 没开通vip 1 是vip 2 vip过期
    couponDialogData:'',//全局优惠券弹窗
    durationTime:60,
    reportCousultDialog:"",
    isVoicepaly:false,
    vipPopWindow:{},
    adsense: [],
    showPopWindowStatus:false,
    sourceId: null,
    woNiuUnique: null,
    tuiliyiKey: null,
  },
  mutations: {
    setWxMiniAppSessionKey (state, value) {
      state.wxMiniAppSessionKey = value;
    },
    setIsWxApp (state, tof) {
      state.isWxApp = !!tof;
    },
    setWxConfig (state, config) {
      state.wxConfig = config;
    },
    // doWxConfig(state, errcallback) {
    //     console.info('微信config');
    //     wxConfig(state.wxConfig, errcallback);
    // },
    setChannelId (state, id) {
      if (id == undefined) return;
      if (id == 'null') {
        state.channelId = 1;
      } else {
        state.channelId = id * 1;
      }
    },
    setYxyid (state, id) {
      if (id == undefined) return;
      if (id == 'null') {
        state.yxyid = "";
      } else {
        state.yxyid = id * 1;
      }
    },
    setChannelConfig (state, config) {
      state.channelConfig = config;
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo;
    },
    setUID (state, uid) {
      if (uid != undefined) {
        state.uid = uid + '';
      }
    },
    setGLOBALLOCK (state, tof) {
      state.GLOBALLOCK = tof;
    },
    setLOADING (state, tof) {
      state.LOADING = !!tof;
    },
    setLOADINGTEXT (state, str) {
      state.LOADINGTEXT = '' + str;
    },
    setTOASTTEXT (state, payload) {
      if (typeof(payload) == 'string') {
        state.TOASTTEXT = '' + payload;
        state.TOASTSTATUS = '';
        state.TOASTTIME = 1300;
      } else {
        let {str, status, time} = payload;
        state.TOASTTEXT = str?str:'';
        state.TOASTSTATUS = status?status:'';
        state.TOASTTIME = time?time:1300;
      }
    },
    // 报告页残留
    setIsReportRecomendShowed (state, payload) {
      state.isReportRecomendShowed = payload;
    },
    setIsReportShareShowed (state, payload) {
      state.isReportShareShowed = payload;
    },
    setIsSendEmailShowed (state, payload) {
      state.isSendEmailShowed = payload;
    },
    setCouponDialogData(state, content){
      console.log('-----setCouponDialogData')
      console.log(content)
      state.couponDialogData = content;
    },
    setVoicepaly(state, payload){
      state.isVoicepaly = payload
    },
    setDurationTime(state, payload){
      state.durationTime = payload
    },
    setReportCousultDialog(state, payload){
      state.reportCousultDialog = payload;
    },
    setVipInfo(state, vipInfo){
      state.vipInfo = vipInfo;
    },
    setVipPopWindow(state, config){
      state.vipPopWindow = config;
      if (!!state.vipPopWindow.pop) {
        state.showPopWindowStatus = true
      }
    },
    setAdsense(state, config){
      state.adsense = config;
    },
    setShowPopWindowStatus(state, payload){
      state.showPopWindowStatus = payload
    },
    setSourceId(state, payload){
      state.sourceId = payload
    },
    setWoNiuUnique(state, payload){
      state.woNiuUnique = payload
    },
    setTuiliyiKey(state, payload){
      state.tuiliyiKey = payload
      console.log('@Store setWoNiuUnique tuiliyiKey', state.tuiliyiKey)
    },
  },
  getters: {
    [`CHANNELID`]: state => state.channelId * 1,
    // 品牌声明
    [`CHANNEL_YXL_STATEMENT`]: state => state.channelConfig.hasBandStament,
    // 渠道在错误页的内容
    [`CHANNEL_ERROR_TEXT`]: function (state) {
      return !state.channelConfig.errorPageText ? `点击下方按钮，在<span class="black">「我的测评」-「未完成」</span>找回本测评继续答题；或者进入公众号，联系客服。` : state.channelConfig.errorPageText;
    },
    [`CHANNEL_ERROR_URL`]: state => state.channelConfig.errorPageUrl,
    [`CHANNEL_USERTYPE`]: state => state.channelConfig.userType,
    // 渠道在报告页的内容
    [`CHANNEL_REPORT_MICRO_TEST`]: state => !!state.channelConfig.whetherInvokePsychoInterface,
    [`CHANNEL_REPORT_SHOW_RECOMMEND`]: state => !!state.channelConfig.whetherShowRecommend,
    [`CHANNEL_REPORT_SHOW_SEND_EMAIL`]: state => !!state.channelConfig.whetherShowSendEmail && state.channelId != 568,
    [`CHANNEL_REPORT_SHOW_SHARE`]: state => !!state.channelConfig.whetherShowShare && state.channelId != 568,
    [`CHANNEL_DISTRIBBUTION`]: state => !!state.channelConfig.channelDistribution,
    [`CHANNEL_INTERNALCHANNEL`]: state => !!state.channelConfig.internalChannel,//ture 内部渠道
    [`CHANNEL_EXTERNALCHANNEL`]: state => state.channelConfig.channelType == 3, // 外部合作渠道
    [`CHANNEL_REPORT_SHOWQRCODE`]: function (state) {
      // 判断内容是否为空
      if (!state.channelConfig.reportPageQrcodeUrl) {
        // 二维码为空，不显示
        return false;
      } else {
        return true;
      }
    },
    [`CHANNEL_BUYMODE`]: state => state.channelConfig.buyMode ? state.channelConfig.buyMode : 0,
    [`CHANNEL_AVOID_PAY_URL`]: state => state.channelConfig.registeredAddress,
    [`CHANNEL_REPORT_QRCODE_URL`]: state => state.channelConfig.reportPageQrcodeUrl,
    [`CHANNEL_REPORT_QRCODE_DESC`]: state => state.channelConfig.reportPageQrcodeDesc,
    [`CHANNEL_CHANNELNAME`]: state => state.channelConfig.name,
    [`CHANNEL_REPORT_PSYCHOINTERFACE`]: state => !!state.channelConfig.whetherInvokePsychoInterface,
    [`CHANNEL_CHANNELTYPE`]: state => (state.channelConfig.channelType == 1||state.channelConfig.channelType == 2)?true:false,
    [`CHANNEL_NOT_LOGIN`]: state => state.channelConfig.channelType == 8 ? true : false,  // 免登陆渠道类型
    [`USER_NICKNAME`]: state => state.userInfo.nickname ? state.userInfo.nickname : '',
    [`USER_AVATAR`]: state => state.userInfo.avatar ? state.userInfo.avatar : '',
    [`USER_TRADETYPE`]: state => {
      if (state.channelConfig.channelType == 8) {
        return ['ALI_PAY_WAP','WX_H5_PAY']
      }else if (state.channelId === 568) {
        return state.userInfo.tradeType ? state.userInfo.tradeType.filter(item => item.includes('WX')) : [];
      } else {
        return state.userInfo.tradeType;
      }
    },
    [`COOKIE_UID`]: state => state.uid,
    [`COUPONDIALOGDATA`]: state => state.couponDialogData,
    [`isVip`]: state => {
      if (!state.vipInfo.status) {
        return 0
      }else{
        return state.vipInfo.status
      }

    }
  },
  actions: {
    // 获取微信JSSDK初始化config信息并初始化
    getWechatData (context, params) {
      if (params.channelId == 2278 || params.channelId == 2310) {
        return
      }
      let o = {
        url: location.href.split('#')[0],
        channelId: params.channelId
      }
      let query = params.query
      // 某些渠道（后端过滤）通过 userKey 变更 sdk 的 appId
      if (query.userKey) {
        o.userKey = query.userKey
      }
      if (query.payUserKey) {
        o.payUserKey = query.payUserKey
      }

      return axios.get(APIS.wechatData, {
        params: o,
      }).then(function (res) {
        if (res.data.code * 1 == 1) {
          context.commit('setWxConfig', res.data.data);
        }
      })
    },
    // 获取用户信息
    pullUserInfo (context, params) {
      let url;
      if (context.state.isWxApp) {
        url = APIS.geWxAppUserInfo;
      } else if ([513, 514].includes(+context.state.channelId)) {
        url = APIS.getPlatformUserInfo;
        if (!params.channelId) {
          params.channelId = context.state.channelId;

        }
      } else {
        url = APIS.getUserInfo
      }
      return axios.get(url, {
        params: params.params
      }).then(function (res) {
        context.commit('setUserInfo', res.data.data);
        callbackHandler(url, res, params.callback);
        try {
          if (res.data.dat) {
            zhuge.identify(res.data.data.userKey, {
              name: res.data.data.nickname,
            });
          }
        } catch (err) {
          console.log(err);
        }
        return res;
      })
    },
    // 从平台userId获取用户信息
    getUserKeyFromPlatfrom(context, params){
      return axios.get(APIS.getUserInfoFromPlatfrom, {params}).then(({data:response})=>{
        let {code, data} = response;
        if(+code ===1) {
          return data.userKey
        }
      })
    },
    // 获取渠道信息
    getChannelMsg (context, params) {
      if (params.params.channelId == null) {
        return;
      }

      return axios.get(APIS.channelConfig, {
        params: params.params
      }).then(function (res) {
        const RES = res.data
        const DATA = RES.data?RES.data:{}
        if (RES.code * 1 == 1 && RES.data) {
          context.commit('setChannelConfig', DATA.channelMsg);
          window.TRACKER.setChannelName(DATA.channelMsg.name);
          window.TRACKER.setInternalChannel(DATA.channelMsg.internalChannel);
          return DATA
        } else {
          window.monitor.stat({
            level: 'error',
            error: 'API-data',
            url: APIS.channelConfig
          });
        }
      })
    },
    receiveCoupon(context, { params }) {
        return axios.get(APIS.receiveCoupon, {
            params: params
        }).then(function(res) {
          console.log('获取优惠券',res.data)
            if (res.data.code == 1) {
              callbackHandler(APIS.receiveCoupon, res.data);
              if (params.displayPlace != 4) { //报告页不需要窗口
                context.commit('setCouponDialogData', res.data.data);
              }
            }
            return res.data;
        })
    },
    fetchVipinfo(context, { params }) {
        return axios.get(APIS.getVipInfo, {
            params: params
        }).then(function(res) {
          console.log('vip状态信息',res.data)
          if (res.data.code == 1 && res.data.data) {
            callbackHandler(APIS.getVipInfo, res.data);
            context.commit('setVipInfo', res.data.data);
          }
          return res.data;
        })
    },
    // 会员弹窗接口
    fecthVipPopWindow(context, params) {
      return axios.get(APIS.vipPopWindow, {
        params: params.params
      }).then(function (res) {
        if (res.data.code == 1) {
          callbackHandler(APIS.vipPopWindow, res);
          context.commit('setVipPopWindow', res.data.data);
          return res.data;
        }
      })
    },
    // 会员弹窗接口
    fetchAdsense(context, params) {
      return axios.get(APIS.fetchAdsense, {
        params: params.params
      }).then(function (res) {
        let data = res.data
        if (data && data.code == 200) {
          callbackHandler(APIS.fetchAdsense, res);
          context.commit('setAdsense', data.data);
          return data;
        }
      })
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js